import { useTranslation } from 'react-i18next';
import { FC, Fragment, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import AddAction from '../../../common/components/actions/add-action-button/AddAction';
import { useGetActionUrls } from '../api/useGetActionUrls';
import QueryErrorViewer from '../../../error/components/error-viewer/QueryErrorViewer';
import ItemsNotFound from '../../../error/components/items-not-found/ItemsNotFound';
import ListView from '../../../common/components/list-view/ListView';
import ListViewItem from '../../../common/components/list-view/ListViewItem';
import ListViewItemIcon from '../../../common/components/list-view/ListViewItemIcon';
import Loader from '../../../common/components/loader/Loader';

import cardStyles from '../../../../theme/styles/Card.module.css';

interface ActionUrlListListProps {
  selectedItemId?: string | null;
}

export const ActionUrlList: FC<ActionUrlListListProps> = ({ selectedItemId })=> {
  const { t } = useTranslation();
  const [, setSearchParams] = useSearchParams();

  const { isLoading, isFetching, isError, error, isSuccess, data } = useGetActionUrls();

  const onClickCreate = useCallback(() => {
    setSearchParams('');
  }, [setSearchParams]);

  const onClickItem = useCallback((obj: any) => {
    setSearchParams({ id: obj.id })
  }, [setSearchParams]);

  return (
    <div className={cardStyles.card}>
      <div className={cardStyles.card_actions_container}>
        <AddAction iconName="AddLink" label={t('common:addActionUrl')} onClick={onClickCreate} />
      </div>
      <div className={cardStyles.card_content}>
        {(isLoading || isFetching) && <Loader />}
        {isError && <QueryErrorViewer error={error}/>}
        {isSuccess && data && (
          <Fragment>
            {(!data.items || !data.items.length) && <ItemsNotFound />}
            {data.items && (
              <ListView>
                {data.items.map((item) => (
                  <ListViewItem
                    key={item.id}
                    isSelected={selectedItemId === item.id}
                    onClick={() => onClickItem(item)}
                    icon={<ListViewItemIcon iconName="Link" />}
                    primaryText={item.title}
                  />
                ))}
              </ListView>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
}
